import { useMemo } from "react";

import type { FilterDefinition } from "@/ds";
import { AUDIT_ACTION_OPTIONS, AUDIT_MODULE_OPTIONS } from "@/modules/audit";
import {
  AUDIT_ACTION_KEY,
  AUDIT_FILTER_LABELS,
  AUDIT_MODULE_KEY,
  AUDIT_RESPONSAVEL_KEY,
  AUDIT_YEAR_KEY,
  AUDIT_YEARS_BACK,
} from "../audit.constants";
import { opcoesDeAno } from "../audit.utils";
import { useAuditResponsavelOptions } from "./use-audit-responsavel-options";

/**
 * Filtros da aba na ordem do Figma 4407:581557 (sem Status, que o serviço não tem): Ano (sempre preenchido), Alteração,
 * Módulo e Responsável. O Responsável vem do cadastro de usuários, e não dos registros já auditados; o Módulo abre sem
 * busca (Figma 5264:65721).
 */
export function useAuditFiltrosColunas(anoCorrente: number): FilterDefinition[] {
  const responsaveis = useAuditResponsavelOptions();

  return useMemo<FilterDefinition[]>(
    () => [
      {
        key: AUDIT_YEAR_KEY,
        label: AUDIT_FILTER_LABELS[AUDIT_YEAR_KEY],
        type: "select",
        options: opcoesDeAno(anoCorrente, AUDIT_YEARS_BACK),
      },
      {
        key: AUDIT_ACTION_KEY,
        label: AUDIT_FILTER_LABELS[AUDIT_ACTION_KEY],
        type: "multiselect",
        options: AUDIT_ACTION_OPTIONS,
        searchPlaceholder: "Buscar alteração",
      },
      {
        key: AUDIT_MODULE_KEY,
        label: AUDIT_FILTER_LABELS[AUDIT_MODULE_KEY],
        type: "select",
        options: AUDIT_MODULE_OPTIONS,
      },
      {
        key: AUDIT_RESPONSAVEL_KEY,
        label: AUDIT_FILTER_LABELS[AUDIT_RESPONSAVEL_KEY],
        type: "multiselect",
        options: responsaveis.options,
        isLoading: responsaveis.isLoading,
        hasError: responsaveis.hasError,
        searchPlaceholder: "Buscar responsável",
      },
    ],
    [anoCorrente, responsaveis],
  );
}
